import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import FullPageSlider from './components/FullPageSlider';
import News from './components/News';
import FlexSlider from './components/FlexSlider';
import Footer from './components/Footer';
import BlogSection from './components/BlogSection';
import VerticalTabs from './components/VerticalTabs';
import Contact from './components/Contact';
import OurPeople from './components/OurPeople';
import OurVision from './components/OurVision';
import AboutUs from './components/AboutUs';
import OurBusiness from './components/OurBusiness';
import Media from './components/Media';
import NotFound from './components/NotFound';
import SEO from './components/SEO';
import ScrollToTop from './components/ScrollToTop';
import StackedCards from './components/StackedCards';
import OurValues from './components/OurValues';
import FilterGallery from './components/FilterGallery';
import CTASection from './components/CTASection';
import CTATwo from './components/CTATwo';
import HorizontalTabs from './components/HorizontalTabs';
import FloatingButtonGroup from './components/FloatingButtonGroup';
import Disclaimer from './components/Disclaimer';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiePolicy from './components/CookiePolicy';
import StatsSection from './components/StatsSection';
import CookieConsentBanner from './components/CookieConsentBanner';
import ProductsPage from './components/Products';
import NewsDetail from './pages/NewsDetail';
import NewsList from "../src/pages/NewsList";
import NewsEditor from "./pages/NewsEditor";
import AllNews from "./pages/AllNews";
import AllBlogs from "./pages/AllBlogs";
import BlogDetail from "./pages/BlogDetail";
import BlogEditor from "./pages/BlogEditor";
import BlogList from "./pages/BlogList";
import { AuthProvider } from "./context/AuthContext";
import RequireAuth from "./components/RequireAuth";
import AdminLogin from "./pages/AdminLogin";
import AdminRegister from "./pages/AdminRegister"; // FIX: was imported nowhere
import AdminDashboard from "./pages/AdminDashboard";
import AdminNavbar from "./components/AdminNavbar";
import AdminFooter from "./components/AdminFooter";
import ManageProducts from './pages/ManageProducts';
import ManageGallery from './pages/ManageGallery';
import ManageTestimonials from './pages/ManageTestimonials';
import Testimonials from './components/Testimonials';
import ManageUsers from './pages/ManageUsers';
import ManageQuotes from './pages/ManageQuotes';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <Routes>
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* FIX: /admin/register was missing — added as a protected route so only
              a logged-in superadmin can reach it (matches the server-side restriction) */}
          <Route path="/admin/register" element={<RequireAuth><AdminNavbar /><AdminRegister /><AdminFooter /></RequireAuth>} />

          <Route path="/admin/dashboard" element={<RequireAuth><AdminNavbar /><AdminDashboard /><AdminFooter /></RequireAuth>} />
          <Route path="/admin/users" element={<RequireAuth><AdminNavbar /><ManageUsers /></RequireAuth>} />
          <Route path="/admin/products" element={<RequireAuth><AdminNavbar /><ManageProducts /><AdminFooter /></RequireAuth>} />
          <Route path="/admin/gallery" element={<RequireAuth><AdminNavbar /><ManageGallery /><AdminFooter /></RequireAuth>} />
          <Route path="/admin/testimonials" element={<RequireAuth><AdminNavbar /><ManageTestimonials /><AdminFooter /></RequireAuth>} />
          <Route path="/admin/quotes" element={<RequireAuth><AdminNavbar /><ManageQuotes /><AdminFooter /></RequireAuth>} />
          <Route path="/newslist" element={<RequireAuth><AdminNavbar /><NewsList /><AdminFooter /></RequireAuth>} />
          <Route path="/bloglist" element={<RequireAuth><AdminNavbar /><BlogList /><AdminFooter /></RequireAuth>} />
          <Route path="/editor" element={<RequireAuth><AdminNavbar /><NewsEditor /><AdminFooter /></RequireAuth>} />
          <Route path="/blog-editor" element={<RequireAuth><AdminNavbar /><BlogEditor /><AdminFooter /></RequireAuth>} />

          <Route path="/" element={<><Navbar /><SEO title="HS India – Women's Ethnic Wear | Sarees, Lehengas & More" description="HS India is a leader in ethnic fashion, blending tradition with innovation. Shop sarees, lehengas, suits and more." canonical="/" /><FullPageSlider /><HorizontalTabs /><StatsSection /><News /><FlexSlider /><VerticalTabs /><CTASection /><OurPeople /><StackedCards /><Testimonials /><OurVision /><OurValues /><BlogSection /></>} />
          <Route path="/contact" element={<><Navbar /><SEO title="Contact Us – HS India" description="Get in touch with HS India. Reach out for queries, collaborations, or business enquiries." canonical="/contact" /><Contact /></>} />
          <Route path="/about" element={<><Navbar /><SEO title="About Us – HS India" description="Learn about HS India's journey, vision, values, and the people behind our ethnic fashion brand." canonical="/about" /><AboutUs /><OurVision /><OurValues /><OurPeople /></>} />
          <Route path="/our-business" element={<><Navbar /><SEO title="Our Business – HS India" description="Discover HS India's business verticals, manufacturing excellence, and distribution across India." canonical="/our-business" /><OurBusiness /><CTASection /><StackedCards /></>} />
          <Route path="/products" element={<><Navbar /><SEO title="Products – HS India | Ethnic Wear Collection" description="Explore HS India's full range of women's ethnic wear — sarees, lehengas, suits, and more." canonical="/products" /><ProductsPage /></>} />
          <Route path="/media" element={<><Navbar /><SEO title="Media & Gallery – HS India" description="Browse HS India's media gallery featuring product showcases, events, and brand moments." canonical="/media" /><Media /><FilterGallery /></>} />
          <Route path="/disclaimer" element={<><Navbar /><SEO title="Disclaimer – HS India" description="Read the legal disclaimer for HS India's website." canonical="/disclaimer" /><Disclaimer /></>} />
          <Route path="/privacy-policy" element={<><Navbar /><SEO title="Privacy Policy – HS India" description="Understand how HS India collects, uses, and protects your personal information." canonical="/privacy-policy" /><PrivacyPolicy /></>} />
          <Route path="/cookie-policy" element={<><Navbar /><SEO title="Cookie Policy – HS India" description="Learn about the cookies used on the HS India website." canonical="/cookie-policy" /><CookiePolicy /></>} />
          <Route path="/news" element={<><Navbar /><SEO title="Latest News – HS India" description="Stay updated with the latest news, announcements, and updates from HS India." canonical="/news" /><AllNews /></>} />
          <Route path="/news/:slug" element={<><Navbar /><NewsDetail /></>} />
          <Route path="/blogs" element={<><Navbar /><SEO title="Blog – HS India | Fashion Insights & Trends" description="Read HS India's blog for fashion tips, ethnic wear trends, styling guides, and brand stories." canonical="/blogs" /><AllBlogs /></>} />
          <Route path="/blogs/:slug" element={<><Navbar /><BlogDetail /></>} />
          <Route path="*" element={<><Navbar /><SEO title="Page Not Found – HS India" description="The page you are looking for does not exist." /><NotFound /></>} />
        </Routes>

        {/* Public site footer — suppressed on all admin and editor routes */}
        <Routes>
          <Route path="/admin/*" element={null} />
          <Route path="/newslist" element={null} />
          <Route path="/bloglist" element={null} />
          <Route path="/editor" element={null} />
          <Route path="/blog-editor" element={null} />
          <Route path="*" element={<><CTATwo /><Footer /><FloatingButtonGroup /><CookieConsentBanner /></>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;